import * as React from 'react';
import ModalContext from '../ModalContext';
export class FlyoutTarget extends React.Component {
    render() {
        const { id, children } = this.props;
        return (React.createElement(ModalContext.Consumer, null, ({ modals }) => {
            const { modalId, isOpen, modalType, hideTarget } = modals.find(({ modalId }) => modalId === id) || {};
            return isOpen && modalId === id && modalType === 'flyout'
                ? children({ hideTarget, isOpen })
                : null;
        }));
    }
}
export default FlyoutTarget;
//# sourceMappingURL=FlyoutTarget.js.map